<template>
  <b-container>
    <pendencies :moduleId="moduleId"></pendencies>
  </b-container>
</template>
<script>
export default {
  name: "ModulePendenciesDisapproved",
  props:{
    moduleId: String
  },
  components: {
    Pendencies: () => import("src/pagesRms/checklist/pendency/Pendencies.vue")
  },
};
</script>
